import { useSsrAdapter as A } from "../../../../../@css-render_vue3-ssr@0.15.14_vue@3.5.18/node_modules/@css-render/vue3-ssr/esm/index.js";
import "../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import R from "../_styles/global/index.cssr.js";
import { configProviderInjectionKey as x } from "../config-provider/src/context.js";
import { cssrAnchorMetaName as v } from "./common.js";
import m from "../../../../../lodash-es@4.17.21/node_modules/lodash-es/merge.js";
import { inject as B, onBeforeMount as D, computed as K } from "../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
function H(n) {
  return n;
}
function _(n, s, d, i, p, t) {
  const l = A(), e = B(x, null);
  if (d) {
    const o = () => {
      const r = t == null ? void 0 : t.value;
      d.mount({
        id: r === void 0 ? s : r + s,
        head: !0,
        props: {
          bPrefix: r ? `.${r}-` : void 0
        },
        anchorMetaName: v,
        ssr: l,
        parent: e == null ? void 0 : e.styleMountTarget
      }), e != null && e.preflightStyleDisabled || R.mount({
        id: "n-global",
        head: !0,
        anchorMetaName: v,
        ssr: l,
        parent: e == null ? void 0 : e.styleMountTarget
      });
    };
    l ? o() : D(o);
  }
  return K(() => {
    var o;
    const {
      theme: {
        common: r,
        self: g,
        peers: b = {}
      } = {},
      themeOverrides: f = {},
      builtinThemeOverrides: u = {}
    } = p, {
      common: O,
      peers: h
    } = f, {
      common: S = void 0,
      [n]: {
        common: C = void 0,
        self: T = void 0,
        peers: M = {}
      } = {}
    } = (e == null ? void 0 : e.mergedThemeRef.value) || {}, {
      common: j = void 0,
      [n]: a = {}
    } = (e == null ? void 0 : e.mergedThemeOverridesRef.value) || {}, {
      common: y,
      peers: N = {}
    } = a, c = m({}, r || C || S || i.common, j, y, O), P = m(
      // {}, executed every time, no need for empty obj
      (o = g || T || i.self) === null || o === void 0 ? void 0 : o(c),
      u,
      a,
      f
    );
    return {
      common: c,
      self: P,
      peers: m({}, i.peers, M, b),
      peerOverrides: m({}, u.peers, N, h)
    };
  });
}
_.props = {
  theme: Object,
  themeOverrides: Object,
  builtinThemeOverrides: Object
};
export {
  H as createTheme,
  _ as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_mixins/use-theme.js
// module id = 7
// module chunks = 41